import React from 'react';
import './StudentSettings.css';
import { FiUser, FiLock, FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useState } from 'react';


function StudentSettings() {
  const navigate = useNavigate();

  const handleSave = (e) => {
    e.preventDefault();

    // ✅ your save logic here (e.g., API call or local state update)

    // ✅ show success message
    Swal.fire({
      title: 'Success!',
      text: 'Your changes have been saved successfully.',
      icon: 'success',
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'save-btn'  // if you want to apply custom styling
      }
    });
  };

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);



  return (
    <div className="settings-container">
      <div className="settings-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>
        <h2 className="settings-title">Student Settings</h2>
      </div>


      <div className="settings-section">
        <h3><FiUser /> Profile Info</h3>
        <div className="form-group">
          <label>Name:</label>
          <input type="text" placeholder="Alex" />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input type="email" placeholder="alex@example.com" />
        </div>
      </div>

      <div className="form-group password-group">
        <label>Old Password:</label>
        <div className="password-wrapper">
          <input
            type={showOldPassword ? 'text' : 'password'}
            placeholder="Enter old password"
          />
          <span
            onClick={() => setShowOldPassword(prev => !prev)}
            className="monkey-icon"
            role="button"
            title="Toggle password visibility"
          >
            {showOldPassword ? '🙈' : '🐵'}
          </span>
        </div>
      </div>

      <div className="form-group password-group">
        <label>New Password:</label>
        <div className="password-wrapper">
          <input
            type={showNewPassword ? 'text' : 'password'}
            placeholder="Enter new password"
          />
          <span
            onClick={() => setShowNewPassword(prev => !prev)}
            className="monkey-icon"
            role="button"
            title="Toggle password visibility"
          >
            {showNewPassword ? '🙈' : '🐵'}
          </span>
        </div>
      </div>


      <button className="save-btn" onClick={handleSave}>Save Changes</button>
    </div>
  );
}

export default StudentSettings;
